export default "__VITE_ASSET__DATbGuPz__"